// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global App Styles */
.App {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* Material-UI Theme Overrides - Modern Professional Styling */
.MuiAppBar-root {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%) !important;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.15) !important;
}

.MuiAppBar-root .MuiToolbar-root {
  padding: 12px 24px !important;
}

.MuiDrawer-paper {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important;
  border-right: 1px solid #e2e8f0 !important;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.05) !important;
}

/* Card Styling - Professional and Modern */
/* Note: background is not !important so inline styles can override for dark themes */
.MuiCard-root {
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
  background: #ffffff;
}

.MuiCard-root:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  transform: translateY(-2px);
}

.MuiCardContent-root {
  padding: 24px !important;
}

/* Typography Improvements */
.MuiTypography-h1 {
  font-size: 2.5rem !important;
  font-weight: 700 !important;
  letter-spacing: -0.02em !important;
}

.MuiTypography-h2 {
  font-size: 2rem !important;
  font-weight: 700 !important;
  letter-spacing: -0.01em !important;
}

.MuiTypography-h3 {
  font-size: 1.75rem !important;
  font-weight: 600 !important;
}

.MuiTypography-h4 {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
}

.MuiTypography-h5 {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
}

.MuiTypography-h6 {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
}

.MuiTypography-body1 {
  font-size: 0.95rem !important;
  line-height: 1.6 !important;
}

.MuiTypography-body2 {
  font-size: 0.875rem !important;
  line-height: 1.57 !important;
}

.MuiTypography-caption {
  font-size: 0.8125rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.01em !important;
}

/* Button Styling */
.MuiButton-root {
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.MuiButton-root:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px);
}

.MuiButton-contained {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}

.MuiButton-outlined {
  border-width: 1.5px !important;
}

/* List Items */
/* Note: No !important on background so dark themes can override */
.MuiListItemButton-root {
  border-radius: 8px;
  margin: 4px 12px;
  transition: all 0.2s ease;
}

.MuiListItemButton-root:hover {
  background-color: rgba(15, 23, 42, 0.05);
}

.MuiListItemButton-root.Mui-selected {
  background-color: rgba(15, 23, 42, 0.1);
  border-left: 3px solid #0f172a;
  padding-left: calc(24px - 3px);
}

/* Table Styling */
/* Note: No !important on colors so dark themes can override */
.MuiTableCell-head {
  background-color: #f1f5f9;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.01em !important;
  border-bottom: 2px solid #e2e8f0;
  color: #1e293b;
}

.MuiTableCell-body {
  font-size: 0.95rem !important;
  padding: 16px !important;
  border-bottom: 1px solid #e2e8f0;
}

.MuiTableRow-root:hover {
  background-color: #f8fafc;
}

/* Chip Styling */
.MuiChip-root {
  font-weight: 600 !important;
  font-size: 0.8125rem !important;
  border-radius: 6px !important;
}

.MuiChip-filled {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

/* TextField Styling */
.MuiTextField-root .MuiOutlinedInput-root {
  border-radius: 8px !important;
}

.MuiOutlinedInput-notchedOutline {
  border-color: #e2e8f0 !important;
  border-width: 1.5px !important;
}

.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #cbd5e1 !important;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #0f172a !important;
  border-width: 2px !important;
}

/* Main Content Area */
main {
  flex-grow: 1;
  padding: 24px;
}

/* Divider Enhancement */
.MuiDivider-root {
  border-color: #e2e8f0 !important;
}

/* Alert Styling */
.MuiAlert-root {
  border-radius: 8px !important;
  border: 1px solid;
  font-weight: 500 !important;
}

.MuiAlert-standardInfo {
  border-color: #06b6d4 !important;
  background-color: #ecf0ff !important;
}

.MuiAlert-standardSuccess {
  border-color: #10b981 !important;
  background-color: #f0fdf4 !important;
}

.MuiAlert-standardWarning {
  border-color: #f59e0b !important;
  background-color: #fffbeb !important;
}

.MuiAlert-standardError {
  border-color: #ef4444 !important;
  background-color: #fef2f2 !important;
}

/* Responsive Design */
@media (max-width: 600px) {
  .MuiAppBar-root .MuiToolbar-root {
    padding: 8px 12px !important;
  }

  main {
    padding: 16px;
  }

  .MuiCardContent-root {
    padding: 16px !important;
  }

  .MuiTypography-h1 {
    font-size: 1.875rem !important;
  }

  .MuiTypography-h2 {
    font-size: 1.5rem !important;
  }

  .MuiTypography-h3 {
    font-size: 1.25rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA,8DAA8D;AAC9D;EACE,wEAAwE;EACxE,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wEAAwE;EACxE,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA,2CAA2C;AAC3C,qFAAqF;AACrF;EACE,yBAAyB;EACzB,wEAAwE;EACxE,iDAAiD;EACjD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,4DAA4D;EAC5D,mDAAmD;AACrD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf,kEAAkE;AAClE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB,8DAA8D;AAC9D;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,oDAAoD;AACtD;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["/* Global App Styles */\n.App {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n/* Material-UI Theme Overrides - Modern Professional Styling */\n.MuiAppBar-root {\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%) !important;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.15) !important;\n}\n\n.MuiAppBar-root .MuiToolbar-root {\n  padding: 12px 24px !important;\n}\n\n.MuiDrawer-paper {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important;\n  border-right: 1px solid #e2e8f0 !important;\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.05) !important;\n}\n\n/* Card Styling - Professional and Modern */\n/* Note: background is not !important so inline styles can override for dark themes */\n.MuiCard-root {\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.MuiCard-root:hover {\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;\n  transform: translateY(-2px);\n}\n\n.MuiCardContent-root {\n  padding: 24px !important;\n}\n\n/* Typography Improvements */\n.MuiTypography-h1 {\n  font-size: 2.5rem !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.02em !important;\n}\n\n.MuiTypography-h2 {\n  font-size: 2rem !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.01em !important;\n}\n\n.MuiTypography-h3 {\n  font-size: 1.75rem !important;\n  font-weight: 600 !important;\n}\n\n.MuiTypography-h4 {\n  font-size: 1.5rem !important;\n  font-weight: 600 !important;\n}\n\n.MuiTypography-h5 {\n  font-size: 1.25rem !important;\n  font-weight: 600 !important;\n}\n\n.MuiTypography-h6 {\n  font-size: 1.125rem !important;\n  font-weight: 600 !important;\n}\n\n.MuiTypography-body1 {\n  font-size: 0.95rem !important;\n  line-height: 1.6 !important;\n}\n\n.MuiTypography-body2 {\n  font-size: 0.875rem !important;\n  line-height: 1.57 !important;\n}\n\n.MuiTypography-caption {\n  font-size: 0.8125rem !important;\n  font-weight: 500 !important;\n  letter-spacing: 0.01em !important;\n}\n\n/* Button Styling */\n.MuiButton-root {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  padding: 10px 20px !important;\n  border-radius: 8px !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n}\n\n.MuiButton-root:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  transform: translateY(-1px);\n}\n\n.MuiButton-contained {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;\n}\n\n.MuiButton-outlined {\n  border-width: 1.5px !important;\n}\n\n/* List Items */\n/* Note: No !important on background so dark themes can override */\n.MuiListItemButton-root {\n  border-radius: 8px;\n  margin: 4px 12px;\n  transition: all 0.2s ease;\n}\n\n.MuiListItemButton-root:hover {\n  background-color: rgba(15, 23, 42, 0.05);\n}\n\n.MuiListItemButton-root.Mui-selected {\n  background-color: rgba(15, 23, 42, 0.1);\n  border-left: 3px solid #0f172a;\n  padding-left: calc(24px - 3px);\n}\n\n/* Table Styling */\n/* Note: No !important on colors so dark themes can override */\n.MuiTableCell-head {\n  background-color: #f1f5f9;\n  font-weight: 700 !important;\n  font-size: 0.875rem !important;\n  letter-spacing: 0.01em !important;\n  border-bottom: 2px solid #e2e8f0;\n  color: #1e293b;\n}\n\n.MuiTableCell-body {\n  font-size: 0.95rem !important;\n  padding: 16px !important;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.MuiTableRow-root:hover {\n  background-color: #f8fafc;\n}\n\n/* Chip Styling */\n.MuiChip-root {\n  font-weight: 600 !important;\n  font-size: 0.8125rem !important;\n  border-radius: 6px !important;\n}\n\n.MuiChip-filled {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n/* TextField Styling */\n.MuiTextField-root .MuiOutlinedInput-root {\n  border-radius: 8px !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: #e2e8f0 !important;\n  border-width: 1.5px !important;\n}\n\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #cbd5e1 !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #0f172a !important;\n  border-width: 2px !important;\n}\n\n/* Main Content Area */\nmain {\n  flex-grow: 1;\n  padding: 24px;\n}\n\n/* Divider Enhancement */\n.MuiDivider-root {\n  border-color: #e2e8f0 !important;\n}\n\n/* Alert Styling */\n.MuiAlert-root {\n  border-radius: 8px !important;\n  border: 1px solid;\n  font-weight: 500 !important;\n}\n\n.MuiAlert-standardInfo {\n  border-color: #06b6d4 !important;\n  background-color: #ecf0ff !important;\n}\n\n.MuiAlert-standardSuccess {\n  border-color: #10b981 !important;\n  background-color: #f0fdf4 !important;\n}\n\n.MuiAlert-standardWarning {\n  border-color: #f59e0b !important;\n  background-color: #fffbeb !important;\n}\n\n.MuiAlert-standardError {\n  border-color: #ef4444 !important;\n  background-color: #fef2f2 !important;\n}\n\n/* Responsive Design */\n@media (max-width: 600px) {\n  .MuiAppBar-root .MuiToolbar-root {\n    padding: 8px 12px !important;\n  }\n\n  main {\n    padding: 16px;\n  }\n\n  .MuiCardContent-root {\n    padding: 16px !important;\n  }\n\n  .MuiTypography-h1 {\n    font-size: 1.875rem !important;\n  }\n\n  .MuiTypography-h2 {\n    font-size: 1.5rem !important;\n  }\n\n  .MuiTypography-h3 {\n    font-size: 1.25rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
